<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span class="form-header">Fórmula - Nova</span>
    </div>
    <div class="row">
      <div class="col-5">
        <el-form ref="form" :model="form" label-width="120px" >
          <el-form-item label="Nome" prop="field" v-bind:error=" errors.nome ? errors.nome[0] : '' ">
            <el-input v-model="form.nome" size="medium" autosize></el-input>
          </el-form-item>
          <el-form-item label="Macro"  prop="field"  v-bind:error=" errors.macro ? errors.macro[0] : '' ">
            <el-input v-model="form.macro" size="medium" ></el-input>
          </el-form-item>
          <div class="bottom clearfix">
            <el-button type="primary" style="float: right;margin: 20px" @click="salvar()" :loading="isSaving">Salvar</el-button>
            <el-button type="danger" style="float: right;margin: 20px" @click="cancelar()">Cancelar</el-button>
          </div>
        </el-form>
      </div>
    </div>

  </el-card>

</template>

<script>
  import ElCard from "element-ui/packages/card/src/main";
  import {mapActions} from 'vuex'
  import ElForm from "element-ui/packages/form/src/form";

  export default {
    components: {
      ElForm,
      ElCard
    },
    name: "formula-create",
    data() {
      return {
        errors: {},
        isSaving : false,
        form: {
          nome: '',
          macro: ''
        }
      }
    },
    methods: {
      ...mapActions('Formula', ['setFormula']),
      cancelar() {
        this.$router.push({name: 'formula.index'})
      },
      async salvar() {
        this.isSaving = true
        this.errors = []
        try {
          const response = await this.setFormula({ ...this.form})
          this.form.nome  = ''
          this.form.macro = ''
          this.$notify.success("Registro Salvo com sucesso!")
        } catch (error) {
          console.log(error.response)
          this.errors = error.response.data.errors
        }
        this.isSaving  = false
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/features/Formula/Create.vue